import { render, staticRenderFns } from "./Bracket16.vue?vue&type=template&id=74a68ee7&scoped=true&"
import script from "./Bracket16.vue?vue&type=script&lang=js&"
export * from "./Bracket16.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a68ee7",
  null
  
)

export default component.exports